import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { ExhibitionClient } from '@Pass-It-Down/exhibition-client'

const url = process.env.REACT_APP_SERVER_URL
const api = new ExhibitionClient({url})
let pager  = null

export const initStoriesPager = (id) =>  {
  return {type: 'stories/initPager', id: id}
}

export const loadStories = createAsyncThunk('stories/loadStories', async () => {
  const  stories = await pager.getPageOfStories()
  const storiesWithAssets = await Promise.all(stories.map(s => api.story().getById(s._id)))
  return storiesWithAssets
})

export const storiesSlice = createSlice({
  name: 'stories',
  initialState: {
    stories: []
  },
  reducers: {
    initPager: (state, action) => {
      const id = action.id
      pager= api.story().getPager({ exhibitId: id, limit: 3, requireLocations: true })
    }
  },
  extraReducers: {
    [loadStories.pending]: (state, action) => {
    },
    [loadStories.fulfilled]: (state, action) => {
      const newStories = [...state.stories, ...action.payload]
      state.stories = [...newStories]
    }
}})

export const selectStories= state => state.stories.stories

export default storiesSlice.reducer
